import { AudioPlay, KAPLAYCtx } from "kaplay";

let bgmPlay: AudioPlay | undefined

export const playBgm = (k: KAPLAYCtx) => {
  if (!bgmPlay) {
    bgmPlay = k.play("bgm", {
      loop: true
    })
  }
}